<template>
  <responsive>
    <template #lg>
      <zb-tooltip ref="drawer" class="relative">
        <template v-slot:trigger="{ toggle, isShowing }">
          <slot>
            <div class="flex items-center w-full relative">
              <input class="custom-select-input input input-tall w-full cursor-pointer"
                readonly
                :placeholder="placeholder"
                :value="currentValue"
                @click="toggle" />
              <svg width="24" height="24" style="right: 10px"
                class="flex-none pointer-events-none absolute"
                :class="{ 'transform rotate-180 fill-secondary': isShowing }">
                <use xlink:href="/img/sprite.svg#ic_chevron-down"></use>
              </svg>
            </div>
          </slot>
        </template>

        <template>
          <slot name="options">
            <ul class="w-full bg-white py-4 mt-2 rounded select-list text-left mdsm:text-center scroller">
              <li
                class="py-2 px-6 cursor-pointer select-item"
                :class="{ [option.class]: Boolean(option.class) }"
                v-for="(option, index) in options"
                :key="index"
                @click="handleSelect(option)">
                {{ option.label }}
              </li>
            </ul>
          </slot>
        </template>
      </zb-tooltip>
    </template>
    <template #mdsm>
      <div @click="$refs.drawer.show()" class="relative">
        <div class="flex items-center w-full relative">
          <input class="input input-tall w-full cursor-pointer"
            readonly
            :placeholder="placeholder"
            :value="currentValue" />
          <svg width="24" height="24" style="right: 10px" class="flex-none pointer-events-none absolute">
            <use xlink:href="/img/sprite.svg#ic_chevron-down"></use>
          </svg>
        </div>
      </div>
      <bottom-drawer ref="drawer" @backdrop-clicked="$refs.drawer.hide()">
        <div class="mobile-select-wrapper">
          <header class="mobile-select-header flex items-center py-4 flex-none h-16">
            <span class="flex-1 font-medium fs-20">{{ placeholder }}</span>
            <button type="button" @click="$refs.drawer.hide()">
              <svg width="24" height="24">
                <use xlink:href="/img/sprite.svg#ic_close"></use>
              </svg>
            </button>
          </header>
          <hr class="border border-black-30" />
          <ul class="mobile-select-list py-6 flex-1 overflow-y-auto list-reset">
            <li v-for="(option, index) in options" :key="index"
              class="mb-6"
              :class="{ [option.class]: Boolean(option.class) }"
              @click="handleSelect(option)">
              {{ option.label }}
            </li>
          </ul>
        </div>
      </bottom-drawer>
    </template>
  </responsive>
</template>

<script>
import BottomDrawer from '../../components/core/BottomDrawer'
import Responsive from '../../components/core/Responsive'
import Tooltip from './Tooltip.vue'

export default {
  components: {
    BottomDrawer,
    Responsive,
    'zb-tooltip': Tooltip
  },
  props: ['placeholder', 'value', 'options'],
  data () {
    return {
      isFocused: false
    }
  },
  computed: {
    currentValue: {
      get () {
        const item = this.options.find(opt => opt.value === this.value)

        if (item) {
          return item.label
        }

        return null
      },
      set () {}
    }
  },
  methods: {
    handleSelect (option) {
      this.$emit('input', option.value)

      if (this.$refs.drawer && this.$refs.drawer.hide) {
        this.$refs.drawer.hide()
      }
    },
    show () {
      if (this.$refs.drawer && this.$refs.drawer.show) {
        this.$refs.drawer.show()
      }
    }
  }
}
</script>

<style scoped>
.select-item:hover {
  background: var(--black-light-1);
}

.select-list {
  max-height: 600px;
  overflow-y: auto;
}

@media (max-width: 1200px) {
  .mobile-select-wrapper {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
  }

  .mobile-select-list {
    max-height: 50vh;
  }

  .mobile-select-header,
  .mobile-select-list {
    width: 320px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 600px) {
  .mobile-select-header,
  .mobile-select-list {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding-left: 24px;
    padding-right: 24px;
  }

  .mobile-select-list {
    max-height: 80vh;
    text-align: left;
  }
}
</style>
